import { FelaCSS } from '@bridebook/ui';
import { adjustBrightness } from '@bridebook/ui/src/fela-utils/color-mixer';
import { FONT_STYLES, PALETTE_COLORS } from '@bridebook/web/lib/wedding-website/constants/themes';
import { Fonts, Palettes } from '@bridebook/web/lib/wedding-website/types';

interface IArgs {
  primaryFont: Fonts;
  secondaryFont: Fonts;
  palette: Palettes;
}

export interface IThemedComponentStyles {
  h1: FelaCSS;
  h2: FelaCSS;
  h3: FelaCSS;
  p: FelaCSS;
  button: FelaCSS;
  buttonText: FelaCSS;
}

export const getThemedComponentStyles = ({
  primaryFont,
  secondaryFont,
  palette,
}: IArgs): IThemedComponentStyles => ({
  // NOTE: perhaps color should use primary/secondary/tertiary (see above) - but they're unreadable as of right now
  h1: {
    fontFamily: FONT_STYLES[primaryFont].fontFamily,
    fontSize: 46,
    color: PALETTE_COLORS[palette].text,
  },
  h2: {
    fontFamily: FONT_STYLES[primaryFont].fontFamily,
    fontSize: 32,
    color: PALETTE_COLORS[palette].text,
  },
  h3: {
    fontFamily: FONT_STYLES[primaryFont].fontFamily,
    fontSize: 22,
    color: PALETTE_COLORS[palette].text,
  },
  p: {
    fontFamily: FONT_STYLES[secondaryFont].fontFamily,
    fontSize: 16,
    color: PALETTE_COLORS[palette].text,
  },
  button: {
    backgroundColor: PALETTE_COLORS[palette].button,

    hover: {
      backgroundColor: adjustBrightness(PALETTE_COLORS[palette].button, 0.9),
      cursor: 'pointer',
    },
    active: {
      backgroundColor: adjustBrightness(PALETTE_COLORS[palette].button, 1.05),
    },
  },
  buttonText: {
    fontFamily: FONT_STYLES[secondaryFont].fontFamily,
    fontSize: 16,
    color: PALETTE_COLORS[palette].buttonText,
    // EB Garamond needs to be 700, the rest should be 600; update font loading mechanisms to only fetch desired sizes
    fontWeight: 600,
  },
});
